import type {TabGroup, TabId} from 'src/features/erp/components/erp-tab-pages/types';
import type {RelatedRecordsTable} from 'src/features/record/kp-related-records-table/types';
import type {Document} from 'src/typings';
import KpRelatedRecordsTable from 'src/features/record/kp-related-records-table/KpRelatedRecordsTable.svelte';

export const RECORD_DETAIL_DETAILS_TAB = 'tab-detail' as TabId;
export const RECORD_DETAIL_DATA_TAB = 'tab-relatedtables' as TabId;
export const RECORD_DETAIL_EXPORT_TAB = 'tab-export' as TabId;
export const RECORD_DETAIL_THREAD_TAB = 'tab-thread' as TabId;
export const RECORD_DETAIL_FILES_TAB = 'tab-files' as TabId;
export const RECORD_DETAIL_TOOLS_TAB = 'tab-tools' as TabId;

export const RECORD_DETAIL_DATA_TABLE_PREFIX = 'tab-relatedtable';

export function createTabGroupFromRelatedTables(relatedTables: RelatedRecordsTable[], record: Document): TabGroup {
    return {
        id: RECORD_DETAIL_DATA_TAB,
        label: 'Datové pohledy',
        icon: 'grid-alt',
        subtabs: relatedTables.map((relatedTable) => ({
            id: `${RECORD_DETAIL_DATA_TABLE_PREFIX}-${relatedTable.tableId}`,
            label: relatedTable.title,
            icon: 'grid-alt',
            render: {
                component: KpRelatedRecordsTable,
                props: {
                    record,
                    fondId: relatedTable.fondId,
                    relations: relatedTable.relations,
                    dynamicFieldSearchParams: relatedTable.dynamicFieldSearchParams,
                    rowCreationParams: relatedTable.rowCreationParams
                }
            }
        }))
    }
}